import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ComplianceBadge } from "@/components/ComplianceBadge";

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/orders/mine").then((r) => { setOrders(r.data); setLoading(false); }).catch(() => setLoading(false)); }, []);
  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-12">
      <div className="eyebrow">Account</div>
      <h1 className="h-display text-4xl mt-2">My orders.</h1>
      <div className="mt-8 border border-[var(--line)] bg-[var(--paper-2)] rounded-md overflow-hidden">
        <table className="w-full data-table">
          <thead>
            <tr>
              <th className="text-left px-4 py-3">Order #</th>
              <th className="text-left px-4 py-3">Date</th>
              <th className="text-left px-4 py-3">Items</th>
              <th className="text-left px-4 py-3">Total</th>
              <th className="text-left px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="px-4 py-6 text-center font-mono text-xs text-[var(--ink-muted)]">Loading…</td></tr>}
            {!loading && orders.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-center font-mono text-xs text-[var(--ink-muted)]">No orders yet.</td></tr>}
            {orders.map((o) => (
              <tr key={o.id} data-testid={`order-row-${o.order_number}`}>
                <td className="px-4 py-3 font-mono">{o.order_number}</td>
                <td className="px-4 py-3 font-mono text-xs">{(o.created_at || "").slice(0, 10)}</td>
                <td className="px-4 py-3 text-xs">{o.items?.length || 0} item(s)</td>
                <td className="px-4 py-3 font-mono">${(o.subtotal_usd || 0).toFixed(2)}</td>
                <td className="px-4 py-3">
                  <ComplianceBadge kind="order_status" value={o.status} />
                  {o.shipping?.tracking_number && (
                    <div className="mt-2 text-[11px] font-mono">
                      <span className="text-[var(--ink-muted)]">{o.shipping.carrier_label || o.shipping.carrier?.toUpperCase()} · </span>
                      {o.shipping.tracking_url ? (
                        <a href={o.shipping.tracking_url} target="_blank" rel="noopener noreferrer" className="text-[var(--terra)] hover:underline" data-testid={`track-link-${o.order_number}`}>
                          {o.shipping.tracking_number} ↗
                        </a>
                      ) : (
                        <span>{o.shipping.tracking_number}</span>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
